import { AsyncSelect as asyncSelect } from "./AsyncSelect";
import { Subtitle as subtitle } from "./Subtitle";
export var fields = {
    asyncSelect: asyncSelect,
    subtitle: subtitle,
};
